import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";
import icon from "../Vis 4/icon.png";
import { MdSubtitles } from "react-icons/md";
// Initialize drilldown module
if (typeof Highcharts === "object") {
  Drilldown(Highcharts);
}

function Cards1() {
  const options = {
    chart: {
      type: "column",
      height: 80, // Restrict height
      spacing: [0, 0, 0, 0],
      backgroundColor: "transparent",
    },
    title: { text: null },
    xAxis: { visible: false },
    yAxis: { visible: false },
    legend: { enabled: false },
    credits: { enabled: false },
    exporting: { enabled: false },
    tooltip: { enabled: true },
    series: [
      {
        data: [10, 3, 2, 4, 8, 4],
        color: "#20486C",
      },
    ],
  };
  const pieOptions = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 100,
      width: 100,
    },
    title: {
      text: null,
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: false,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    series: [
      {
        name: "Share",
        colorByPoint: true,
        data: [
          { name: "Used", y: 75, color: "#20486C" },
          { name: "Remaining", y: 25, color: "lightgrey" },
        ],
      },
    ],
  };
  const optionsLine = {
    chart: {
      type: "line",
      height: 60,
      width: 150,
      backgroundColor: "transparent",
      margin: [5, 5, 5, 5],
    },
    title: {
      text: null,
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
        lineWidth: 2,
        enableMouseTracking: false,
      },
    },
    exporting: { enabled: false },
    series: [
      {
        data: [2, 3, 2.5, 4, 3.8],
        color: "#20486C",
      },
    ],
    credits: {
      enabled: false,
    },
  };
  const Drilldownoptions = {
    chart: {
      type: "column",
      height: 130,
      width: 150,
      backgroundColor: "transparent",
    },

    title: {
      text: null,
    },

    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: false,
        },
        color: "#20486C", // First-level color
      },
    },
    tooltip: {
      enabled: false,
    },
    exporting: { enabled: false },

    series: [
      {
        name: "Browsers",
        colorByPoint: false, // Disable color by point
        data: [
          { name: "Chrome", y: 63.06, drilldown: "Chrome" },
          { name: "Safari", y: 19.84, drilldown: "Safari" },
          { name: "Firefox", y: 4.18, drilldown: "Firefox" },
          { name: "Edge", y: 4.12, drilldown: "Edge" },
          { name: "Opera", y: 2.33, drilldown: "Opera" },
          {
            name: "Internet Explorer",
            y: 0.45,
            drilldown: "Internet Explorer",
          },
          { name: "Other", y: 1.582 },
        ],
      },
    ],
    credits: { enabled: false },
    drilldown: {
      breadcrumbs: {
        position: {
          align: "right",
        },
        buttonTheme: {
          style: {
            fontSize: "8px", // Smaller breadcrumb font
          },
        },
      },
      activeAxisLabelStyle: {
        color: "#EEEEEE",
      },
      activeDataLabelStyle: {
        color: "#EEEEEE",
      },
      series: [
        {
          name: "Chrome",
          id: "Chrome",
          color: "#EEEEEE", // Drilldown color
          data: [
            ["v65.0", 0.1],
            ["v64.0", 1.3],
            ["v63.0", 12.02],
            ["v62.0", 1.4],
            ["v61.0", 0.88],
            ["v60.0", 0.56],
            ["v59.0", 0.45],
            ["v58.0", 0.49],
            ["v57.0", 0.32],
            ["v56.0", 0.29],
            ["v55.0", 0.79],
            ["v54.0", 0.18],
            ["v51.0", 0.13],
            ["v49.0", 2.16],
            ["v48.0", 0.13],
            ["v47.0", 0.11],
            ["v43.0", 0.17],
            ["v29.0", 0.26],
          ],
        },
        {
          name: "Firefox",
          id: "Firefox",
          color: "#EEEEEE",
          data: [
            ["v58.0", 1.02],
            ["v57.0", 7.36],
            ["v56.0", 0.35],
            ["v55.0", 0.11],
            ["v54.0", 0.1],
            ["v52.0", 0.95],
            ["v51.0", 0.15],
            ["v50.0", 0.1],
            ["v48.0", 0.31],
            ["v47.0", 0.12],
          ],
        },
        {
          name: "Internet Explorer",
          id: "Internet Explorer",
          color: "#EEEEEE",
          data: [
            ["v11.0", 6.2],
            ["v10.0", 0.29],
            ["v9.0", 0.27],
            ["v8.0", 0.47],
          ],
        },
        {
          name: "Safari",
          id: "Safari",
          color: "#EEEEEE",
          data: [
            ["v11.0", 3.39],
            ["v10.1", 0.96],
            ["v10.0", 0.36],
            ["v9.1", 0.54],
            ["v9.0", 0.13],
            ["v5.1", 0.2],
          ],
        },
        {
          name: "Edge",
          id: "Edge",
          color: "#EEEEEE",
          data: [
            ["v16", 2.6],
            ["v15", 0.92],
            ["v14", 0.4],
            ["v13", 0.1],
          ],
        },
        {
          name: "Opera",
          id: "Opera",
          color: "#EEEEEE",
          data: [
            ["v50.0", 0.96],
            ["v49.0", 0.82],
            ["v12.1", 0.14],
          ],
        },
      ],
    },
  };

  return (
    <div style={{ height: "250px", marginBottom: "20px" }}>
      <div className="row mb-4">
        <div className="col-md-4">
          <div
            className="card bg-light text-center"
            style={
              {
                // border: "none",
                // boxShadow:
                //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              }
            }
          >
            <div
              className="card-body"
              style={{
                padding: "20px",
                textAlign: "left",
                backgroundColor: "white",
                borderRadius: "7px",
                // border: "none",
              }}
            >
              <h5
                style={{
                  fontSize: "16px",
                  fontFamily: "'Roboto Flex', serif",
                  color: "#3B3A3A",
                }}
              >
                Overall Data Completeness
              </h5>
              <h4 style={{ fontSize: "22px" }}>93.61%</h4>
              <p>
                <span style={{ color: "#20486C", fontWeight: "700" }}>
                  {" "}
                  Network A
                </span>{" "}
                has the most data completeness with an index of <b>97.19%</b>.
              </p>
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                containerProps={{ style: { width: "100%" } }}
              />
            </div>
          </div>
        </div>
        <div
          className="col-md-4 d-flex flex-column justify-content-around m0"
          style={{ gap: "10px" }}
        >
          <div
            className="card text-center"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: "70%",
              padding: "10px 20px",
              backgroundColor: "#F4FAFF ",
              border: "none",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
              gap: "10px",
            }}
          >
            <div>
              <img src={icon}></img>
            </div>
            <div
              className="card-body"
              style={{
                padding: "10px",
                backgroundColor: "#F4FAFF",
                border: "none",
                borderRadius: "7px",
                textAlign: "left",
              }}
            >
              <h5 style={{ fontSize: "16px", color: "#20486C" }}>
                MRF Record Count
              </h5>
              <p className="card-text display-11">
                <b style={{ color: "#20486C" }}>11,809M</b>
              </p>
            </div>
            <div>
         
              <HighchartsReact
                highcharts={Highcharts}
                options={Drilldownoptions}
              />
            </div>
          </div>

          <a
            className="card bg-light text-center"
            href="/Diverging-Bar3"
            style={{
              height: "30%",
              textDecoration: "none",
            }}
          >
            <div
              className="card-body"
              style={{
                padding: "10px",
                background: "#12273B",
                border: "none",
                borderRadius: "7px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {" "}
                <small
                  className="d-block"
                  style={{ textAlign: "left", color: "white" }}
                >
                  Saved Network Categories Title
                </small>
                {/* <img src="../Vector.png"></img> */}
                <b style={{ color: "white" }}>&#10095;</b>
              </div>

              <div className="d-flex flex-wrap gap-2 mt-2">
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  BCBS
                </span>
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  Category III
                </span>
              </div>
            </div>
          </a>
        </div>
        <div
          className="col-md-4 d-flex flex-column justify-content-around m0"
          style={{ gap: "10px" }}
        >
          <div
            className="card text-center"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: "70%",
              padding: "10px 20px",
              backgroundColor: "#F4FAFF ",
              border: "none",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
              gap: "10px",
            }}
          >
            <div>
              <img src={icon}></img>
            </div>
            <div
              className="card-body"
              style={{
                padding: "10px",
                backgroundColor: "#F4FAFF",
                border: "none",
                borderRadius: "7px",
                textAlign: "left",
              }}
            >
              <h5 style={{ fontSize: "16px", color: "#20486C" }}>
                MRF Record Count
              </h5>
              <p className="card-text display-11">
                <b style={{ color: "#20486C" }}>11,809M</b>
              </p>
            </div>
            <div>
              <HighchartsReact highcharts={Highcharts} options={optionsLine} />
            </div>
          </div>
          <div
            className="card bg-light text-center"
            style={{
              height: "30%",
            }}
          >
            <div
              className="card-body"
              style={{
                padding: "10px",
                background: "#12273B",
                border: "none",
                borderRadius: "7px",
              }}
            >
              {/* <h5 style={{ fontSize: "16px" }}>MRF Record Count</h5>
              <p className="card-text display-11">11,809M</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <small
                  className="d-block"
                  style={{ textAlign: "left", color: "white" }}
                >
                  Saved Query Title
                </small>
                {/* <img src="../Vector.png"></img> */}
                <b style={{ color: "white" }}>&#10095;</b>
              </div>

              <div className="d-flex flex-wrap gap-2 mt-2">
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  BCBS
                </span>
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  Category III
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cards1;
